module.exports = __webpack_public_path__ + "static/media/ic_search.542bb673.svg";